export default __webpack_public_path__ + "static/media/php.235de469.svg";